export const PLATFORM_MODULES = [
  "dashboard",
  "customers",
  "sales",
  "sellers",
  "catalog",
  "contracts",
  "billing",
  "split",
  "commissions",
  "telemedicine",
  "funeral_assistance",
  "assets",
  "vehicle_sales",
  "property_leases",
  "vehicle_rentals",
  "asset_expenses",
  "receivable_schedules",
  "public_payment_portal",
  "client_portal",
  "public_onboarding",
  "integrations",
  "imports",
  "reports",
  "audit",
  "settings",
  "customer_360",
  "custom_fields",
  "workflow_engine",
  "notifications",
  "document_builder",
  "universal_importer",
  "support_console",
  "saas_metering",
  "universal_billing",
  "software_contracts",
] as const;

export type PlatformModule = (typeof PLATFORM_MODULES)[number];

export const MODULE_DEPENDENCIES: Partial<Record<PlatformModule, PlatformModule[]>> = {
  sales: ["customers", "sellers", "catalog"],
  contracts: ["customers", "catalog"],
  billing: ["customers", "contracts"],
  split: ["billing"],
  commissions: ["sales", "billing", "sellers"],
  telemedicine: ["customers", "contracts", "billing"],
  funeral_assistance: ["customers", "contracts"],
  assets: ["customers"],
  vehicle_sales: ["assets", "customers", "contracts", "billing", "receivable_schedules"],
  property_leases: ["assets", "customers", "contracts", "billing", "receivable_schedules"],
  vehicle_rentals: ["assets", "customers", "contracts", "billing", "receivable_schedules"],
  asset_expenses: ["assets", "billing"],
  receivable_schedules: ["billing", "contracts"],
  public_payment_portal: ["customers", "billing", "receivable_schedules"],
  client_portal: ["customers", "contracts", "billing"],
  public_onboarding: ["customers", "catalog", "sales"],
  reports: ["dashboard"],
  imports: ["customers"],
  customer_360: ["customers", "contracts", "billing"],
  custom_fields: ["settings"],
  workflow_engine: ["settings", "integrations"],
  notifications: ["customers", "integrations"],
  document_builder: ["contracts", "settings"],
  universal_importer: ["imports", "custom_fields"],
  support_console: ["integrations", "audit"],
  saas_metering: ["dashboard"],
  universal_billing: ["billing", "contracts"],
  software_contracts: ["contracts", "universal_billing", "receivable_schedules"],
};

export function resolveModules(requested: readonly PlatformModule[]): PlatformModule[] {
  const resolved = new Set<PlatformModule>();
  const visit = (module: PlatformModule) => {
    for (const dependency of MODULE_DEPENDENCIES[module] ?? []) visit(dependency);
    resolved.add(module);
  };
  for (const module of requested) visit(module);
  return PLATFORM_MODULES.filter((module) => resolved.has(module));
}
